export const SET_VEHICLE = "SET_VEHICLE";
export const CREATE_VEHICLE = "CREATE_VEHICLE";
export const VEHICLES_RECEIVED = "VEHICLES_RECEIVED";
export const SET_PROPERTY_VEHICLE = "SET_PROPERTY_VEHICLE";
